var React = require('react');

function SvgTwitterInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M14.39 3.317v.437c0 4.19-3.32 8.817-9.359 8.817-1.911 0-3.622-.349-5.031-1.222.302 0 .503.088.805.088 1.51 0 3.019-.524 4.126-1.397-1.409 0-2.617-.96-3.12-2.183.202 0 .403.087.604.087.302 0 .704 0 1.006-.087-1.61-.35-2.515-1.659-2.515-3.23 0 .262.704.35 1.207.436-.905-.61-1.409-1.57-1.409-2.619 0-.61.101-1.134.403-1.571 1.61 1.92 3.924 3.143 6.641 3.317v-.785C7.748 1.659 9.258 0 11.07 0c.906 0 1.811.611 2.415 1.222a10.38 10.38 0 002.114-.785c-.202.698-.806 1.396-1.41 1.746A7.094 7.094 0 0016 1.659c-.402.698-1.006 1.222-1.61 1.658z","fill":"#71706A"}));
}

SvgTwitterInline.defaultProps = {"width":"16","height":"13","fill":"none"};

module.exports = SvgTwitterInline;

SvgTwitterInline.default = SvgTwitterInline;
